/**
 * One-time server CSV sort field/dir when the modal opens.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useEffect, useRef, useState } from 'react';

import type { ServerCsvExportSortConfig } from '../server-sort';

export function useCsvExportServerSortInit(
  open: boolean,
  serverCsvSortConfig?: ServerCsvExportSortConfig,
) {
  const [exportSortField, setExportSortField] = useState('');
  const [exportSortDir, setExportSortDir] = useState<'asc' | 'desc'>('desc');
  const serverSortInitRef = useRef(false);

  useEffect(() => {
    if (!open) {
      serverSortInitRef.current = false;
      return;
    }
    if (!serverCsvSortConfig?.options?.length) return;
    if (serverSortInitRef.current) return;
    serverSortInitRef.current = true;
    const allowed = new Set(serverCsvSortConfig.options.map((o) => o.key));
    const d = serverCsvSortConfig.defaultSort;
    setExportSortField(d?.field && allowed.has(d.field) ? d.field : '');
    setExportSortDir(d?.dir === 'asc' ? 'asc' : 'desc');
  }, [open, serverCsvSortConfig]);

  return { exportSortField, setExportSortField, exportSortDir, setExportSortDir };
}
